import React, { Component } from 'react';
import {loadCsrf} from './../../common/CsrfFetcher';

class SelectOrgToJoinModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgToJoinCandidateNames: [],
			selectedOrgToJoin:"",
			selectedOrgNameToJoin:"",
			csrfToken:'',
			showJoinOrganizationPendingModal: false,
			pendingRequestOrgName:""
		};
	}

	validateForm = () => {
		 const joinOrgForm = this.joinOrgForm;
		 const formLength = joinOrgForm.length;
		 for (let i = 0; i < formLength; i++) {
			const elem = joinOrgForm[i];
			if(elem.value === "")	{
				return false;
			}
		 }
		 return true;
	}

	componentDidMount() {
		loadCsrf(this.setCsrfState);
	}
	
	componentDidUpdate(prevProps, prevState) {
		if(prevProps.showSelectOrgToJoinModal !== this.props.showSelectOrgToJoinModal){
			if(this.props.showSelectOrgToJoinModal) {
				this.modalOpen.click();
				this.setOptionsForJoinToOrgCandidates();
			} else {
				this.modalClose.click();
			}
		}

		if(prevState.showJoinOrganizationPendingModal !== this.state.showJoinOrganizationPendingModal){
			if(this.state.showJoinOrganizationPendingModal) {
				this.pendingModalOpen.click();
			} else {
				this.pendingModalClose.click();
			}
		}
	}

	setCsrfState = (csrfToken, csrfHeaderValue) => {
		var state = this.state;
		state.csrfToken = csrfToken;
		this.csrfHeaderValue = csrfHeaderValue;
		this.setState({
			state
		});
	}

	validateResponse = (response) => {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}

	logResult = (result) => {
		console.log('I love this result .... \n\n\n', result);
	}

	handleOrgNameSelectionChange = (event) => {
		var selectedIndex = event.target.selectedIndex;
		var selectedOrgId = event.target.options[selectedIndex].value;
		var selectedOrgName = event.target.options[selectedIndex].innerHTML;
		this.setState({
			selectedOrgToJoin: selectedOrgId,
			selectedOrgNameToJoin: selectedOrgName
		});
	}

	handleOrgJoin = (event) => {
		if(this.validateForm())	{
			this.getUserJoinRequestStatus();
		}
	}

	setOptionsForJoinToOrgCandidates = () => {

		let orgToJoinCandidateNames = this.props.orgSearchResults.map((org) =>
                <option key={org.organizationId} value={org.organizationId}>{org.name}</option>
		);
		
		this.setState({
			orgToJoinCandidateNames: orgToJoinCandidateNames
		});
	}

	hideJoinOrganizationPendingModal = (event) => {
		this.setState({
			showJoinOrganizationPendingModal: false
		});
	}

	getUserJoinRequestStatus = () => {
		console.log('getUserJoinRequestStatus ' + this.state.selectedOrgToJoin);
		console.log('url is ' + process.env.REACT_APP_HOST_API_URL);
		var jsonData = null;
		return fetch(process.env.REACT_APP_HOST_API_URL  +  '/developer/mvc/organization/join/pendingJoinRequestStatus' , {
				method: 'get',
				headers: {
					'Accept': 'application/json',
		            'Content-Type': 'application/json'
				},
				credentials: 'include'
			})
			.then(results => {
				this.validateResponse(results);
				this.logResult(results);
				return results.json();
			})
			.catch(error => {
				console.log('error trying to fetch orgs : \n', error);
				return Promise.reject()
			})
			.then(data => {
				console.log(data);
				if(data.userJoinRequestStatus === 'PENDING')	{
					//show the join pending modal
					this.props.hideSelectOrgToJoinModal();
					this.setState({
						showJoinOrganizationPendingModal: true,
						pendingRequestOrgName: data.pendingRequestOrgName
					});
					console.log("userJoinRequestStatus " + data.userJoinRequestStatus);
				} else{
					this.sendRequestToJoinOrg();
				}
				return jsonData;
			});
	}

	sendRequestToJoinOrg = () => {
		this.setState({
			showJoinOrganizationPendingModal: false
		});

		console.log('sending request to join org ' + this.state.selectedOrgToJoin);
		console.log('csrf token ' + this.state.csrfToken);
		console.log('url is ' + process.env.REACT_APP_HOST_API_URL);

		var jsonData = null;

		return fetch(process.env.REACT_APP_HOST_API_URL  +  '/developer/mvc/organization/join?orgId=' + this.state.selectedOrgToJoin , {
				method: 'post',
				headers: {
					'Accept': 'application/json',
		            'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.state.csrfToken
				},
				credentials: 'include'
			})
			.then(results => {
				this.validateResponse(results);
				this.logResult(results);
				return results.json();
			})
			.catch(error => {
				console.log('error trying to fetch orgs : \n', error);
				return Promise.reject()
			})
			.then(data => {
				console.log(data);
				this.props.handleResponseForOrgJoinRequest(data);
				return jsonData;
			});
	}

	render () {
		return (
				<div>
				<input type="hidden" ref={elem => this.modalOpen = elem} id="modalOpen" data-bs-toggle="modal" data-bs-target="#selectOrgToJoinModal"/>
				<div className="modal fade" id="selectOrgToJoinModal" tabIndex="-1" role="dialog" aria-labelledby="selectOrgToJoinModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Do you want to join an existing Organization/Company?</h5>
                      <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
	                    <div className="description-text form-group">
						The organization/company name that you provided is similar to one or more of our
						existing registered organizations/companies. You can join an existing
						organization/company or you can create your own organization/company by clicking
						"Cancel" and continue to fill out your organization/company info on the
						organization/company form.
						</div>
						<div className="form-group">
							<h3 className="text-bold form-heading">Organization/Company Match</h3>
							<p className="text-orange">Our results found one or more similar matches. Please select an organization/company or click "Cancel" to create your own organization/company.</p>
						</div>
						<form id="joinOrgForm" className="customForm" ref={form => (this.joinOrgForm = form)}>
							<select required className="form-control" onChange={this.handleOrgNameSelectionChange} aria-required="true" name="joinOrgCandidates">
								<option value="">Select</option>
								{this.state.orgToJoinCandidateNames}
						</select>
						</form>
                    </div>
                    <div className="modal-footer">
	                    <button className='btn btn-primary' onClick={this.handleOrgJoin} name="Join">
							Join
						</button>
						<button className='btn btn-secondary' onClick={this.props.hideSelectOrgToJoinModal} ref={elem => this.modalClose = elem} id="modalClose" data-bs-dismiss="modal">
							Cancel
						</button>
                    </div>
                  </div>
                </div>
              </div>

         	<input type="hidden" id="pendingModalOpen" ref={elem => this.pendingModalOpen = elem} data-bs-toggle="modal" data-bs-target="#joinOrganizationPendingModal"/>
			<div className="modal fade" id="joinOrganizationPendingModal" tabIndex="-1" role="dialog" aria-labelledby="joinOrganizationPendingModalLabel" aria-hidden="true">
             <div className="modal-dialog" role="document">
               <div className="modal-content">
                 <div className="modal-header">
                 	Join Organization/Company Pending
                 </div>
                 <div className="modal-body">
                 	By submitting this new request to join {this.state.selectedOrgNameToJoin} your pending request to join {this.state.pendingRequestOrgName} will be canceled. Are you sure
					your want to proceed?
                 </div>
                 <div className="modal-footer">
					<button className='btn btn-primary' onClick={this.sendRequestToJoinOrg} name="YES">
	             		YES
	           		</button>
	           		<button ref={elem => this.pendingModalClose = elem} className='btn btn-secondary' onClick={this.hideJoinOrganizationPendingModal} id="pendingModalClose" data-bs-dismiss="modal">
	            		NO
	           		</button>
                 </div>
               </div>
             </div>
           </div>
           </div>
		)
	}
}

export default SelectOrgToJoinModal;



// WEBPACK FOOTER //
// ./src/manageMyAccount/modals/SelectOrgToJoinModal.js